import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import MaterialTable from "material-table";

import styles from "./styles";
import { formatDate } from "../../../../../Utilities/Functions";
import {
  tableStyle,
  tableOptions,
  tableIcons,
} from "../../../../../Component/Table/tableCommonStyles";

import { Chip } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(styles);

const CommentsTable = ({ comments, onRowDownloadClick }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const renderScoreDocuments = (rowData) => {
    const { documents = [] } = rowData;

    return (
      documents &&
      documents.map((e) => {
        return (
          <>
            <Chip
              size={"small"}
              style={{ margin: 3 }}
              clickable={true}
              onClick={(event) => onRowDownloadClick(e)}
              label={e.file_name}
            />
            <br />
          </>
        );
      })
    );
  };

  return (
    <div className={classes.tableWrapper}>
      <MaterialTable
        style={tableStyle}
        icons={tableIcons}
        options={{ ...tableOptions, sorting: true }}
        isLoading={false}
        data={comments}
        localization={{
          header: {
            actions: t("labels.common.table.actions"),
          },
          body: {
            emptyDataSourceMessage: t("labels.common.table.noRecordsFound"),
          },
        }}
        columns={[
          { title: t("labels.record.comments.action"), field: "action" },
          {
            title: t("labels.record.comments.comment"),
            field: "comments",
          },
          {
            title: t("labels.record.comments.user"),
            field: "email",
            render: (rowData) => {
              return (
                <span> {`${rowData.user_name} (${rowData.user_email})`} </span>
              );
            },
          },
          {
            title: t("labels.record.comments.date"),
            field: "date",
            cellStyle: {
              wordBreak: "break-word",
              wordWrap: "break-word",
            },
            render: (rowData) => {
              return <span> {formatDate(rowData.created_date, true)} </span>;
            },
          },
          {
            title: t("labels.record.comments.documents"),
            field: "documents",
            render: (rowData) => {
              return renderScoreDocuments(rowData);
            },
          },
        ]}
      />
    </div>
  );
};

export default CommentsTable;
